@let stringValue = value();
@if(stringValue) {
  <pre class="bg-grey text-light border rounded px-3 py-2 mb-0 font-monospace small overflow-auto">{{ stringValue }}</pre>
} @else {
  -
}
